<template>
  <div class="flex flex-col justify-between items-start box-border w-full mt-4 p-3">
    <div class="flex gap-1 flex-col sm:flex-row flex-wrap items-start justify-start w-full">
      <FiltersComponent
        :allowFilter="{
          team: true,
          tag: true
        }"
        :max="mindsetMaxSelection"
        :multiple="false"
        :modelValue="selections"
        @update:modelValue="saveSelection"
      />
    </div>
    <div class="flex flex-row items-center space-x-3">
      <MessageBoxComponent v-if="selections.length > 0"
        :isWarning="false" :text="$t('mngDashboardComponent.clickToCompareCompany')"/>
      <ToggleSwitch id="compareToCompanyId" v-if="selections.length > 0"
        v-model="isCompareToCompany" @change="compareToCompany"/>
    </div>
    <MessageBoxComponent is-warning :text="mindsetWarning" />
    <div class="relative w-full flex flex-col justify-start items-stretch mt-5 box-border
      text-left gap-3">
      <div class="card w-full min-h-52">
        <div class="flex w-full justify-between items-center">
          <h2>
            {{ $t('mngDashboardComponent.theOMindsetInYourCompany') }}</h2>
          <Select v-model="mindSetSelectFilter" :options="mindsetPeriod" optionLabel="name"
          option-value="identifier" @change="mindSetOverAllFunction()"/>
        </div>
        <div class="relative w-full h-[400px] min-h-[400px]" tabindex="0">
          <OMindSetCompanyChart ref="mindSetCompany" />
        </div>
      </div>
      <div class="flex justify-start flex-col items-start box-border gap-3 w-full"
          v-if="mindsetTipText.length > 0">
        <div class="card">
          <template v-for="(tip,i) in mindsetTipText" :key="i">
            <div class="flex flex-col md:flex-row" v-if="tip?.length > 0">
              <OMindsetDevelopmentTip  :class="`md:w-[${100 / tip.length}%] w-full`"
               v-for="t in tip" :key="t?.title" :data="t"/>
            </div>
            <OMindsetDevelopmentTip v-else :data="tip"/>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../managementDashboard.css';
import OMindSetCompanyChart from '@/components/Home/ManagementDashboard/OmindsetComponent/OmindsetChartComponent.vue';
import OMindsetDevelopmentTip from '@/components/Home/ManagementDashboard/OmindsetComponent/OmindsetDevelopmentTipComponent.vue';
import FiltersComponent from '@/components/Home/ManagementDashboard/common/FiltersComponent.vue';
import MessageBoxComponent from '@/components/Home/ManagementDashboard/common/MessageBoxComponent.vue';
import { generateListColors, addMissingColor } from '@/helpers/graphPlotHelper';
import { Select, ToggleSwitch } from 'primevue';

export default {
  name: 'OmindsetComponent',
  data() {
    return {
      currentSelections: [],
      mindSetSelectFilter: 'AllTime',
      showAverageText: true,
      isCompareToCompany: false,
      selectionCompareToCompany: {
        name: {
          en: 'Whole Organization',
          de: 'Ganzes Unternehmen',
        },
        selection: {},
        wholeCompany: true,
        color: '#ff0000',
      },
    };
  },
  components: {
    MessageBoxComponent,
    OMindsetDevelopmentTip,
    OMindSetCompanyChart,
    FiltersComponent,
    Select,
    ToggleSwitch,
  },
  computed: {
    selections: {
      get() {
        return this.$store.getters.getSelections;
      },
      set(value) {
        this.$store.commit('setSelections', value);
      },
    },
    oMindSetCompanyData() {
      return this.$store.getters.getOmindset?.oMindSetCompanyData;
    },
    mindsetTipText() {
      return this.$store.getters.getOmindset?.mindsetTipText;
    },
    mindsetPeriod() {
      return this.$store.getters.getOmindset?.mindsetPeriod;
    },
    mindsetWarning() {
      return this.$store.getters.getOmindset?.warning;
    },
    mindsetMaxSelection() {
      return this.$store.getters.getOmindset?.maxSelection;
    },
  },
  methods: {
    // --------- Main Function to call the api on every filters change ---------------- //
    async mindSetOverAllFunction() {
      try {
        const selections = this.prepareSelection();
        await this.$store.dispatch('fetchInitialMindSetCompanyData', {
          selections,
          mindsetPeriodType: this.mindSetSelectFilter,
        });
        this.$refs.mindSetCompany?.OMindSetCompanyCharts(this.oMindSetCompanyData);
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check Console output!',
          detail: '',
          life: 3000,
        });
      }
    },
    compareToCompany() {
      // this.isCompareToCompany = !this.isCompareToCompany;
      this.mindSetOverAllFunction();
    },

    saveSelection(selection, flag = false) {
      const selectionHasColors = this.currentSelections.filter((s) => s.color);
      const selections = selection.map((s) => {
        const matchSelection = selectionHasColors.find((z) => z.name.en === s.name.en);
        if (!matchSelection) return s;
        return {
          ...s,
          color: matchSelection.color,
        };
      });
      this.currentSelections = [...selections];
      if (flag === false) this.selections = [...selections];
    },
    prepareSelection() {
      const listColors = generateListColors(
        this.isCompareToCompany ? this.currentSelections.length + 1 : this.currentSelections.length,
      );
      const ableSelectionColor = this.currentSelections.filter((s) => s.color).map((s) => s.color);
      addMissingColor(listColors, ableSelectionColor);
      this.currentSelections = this.currentSelections.map((s, i) => ({
        ...s,
        color: ableSelectionColor[i],
      }));
      if (this.isCompareToCompany && this.currentSelections.length > 0) {
        return [
          ...this.currentSelections,
          this.selectionCompareToCompany,
        ];
        // eslint-disable-next-line no-else-return
      } else {
        this.isCompareToCompany = false;
      }
      return this.currentSelections;
    },
  },
  watch: {
    selections(value) {
      this.saveSelection(value, true);
      this.mindSetOverAllFunction();
    },
  },
  mounted() {
    this.mindSetOverAllFunction();
  },
};
</script>
